<script setup lang="ts">
  // Components
  import SearchDocumentsTableRow from './SearchDocumentsTableRow.vue';
  import SearchResultsTable, { type SearchTableColumn } from './SearchResultsTable.vue';

  // Interfaces
  import type { DocumentRevision } from '@/entities/Document';
  import type { OrderOptions } from '@/shared/lib';

  defineProps<{
    revisions: DocumentRevision[];
    orderOptions?: OrderOptions[];
    isFilterActive?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'update:sort', sortCamp: string, orderFlow: string): void;
    (e: 'filter-clicked'): void;
  }>();

  const LEFT_HEADER_CLASS =
    'text-left text-xs font-semibold text-gray-07 pl-6 pr-0 py-3 whitespace-nowrap align-middle';

  const columns: SearchTableColumn[] = [
    { text: 'Prefixo', thClass: LEFT_HEADER_CLASS },
    { text: 'Título', thClass: LEFT_HEADER_CLASS },
    {
      text: 'Status',
      thClass: 'text-center text-xs font-semibold text-gray-07 px-0 py-3 whitespace-nowrap align-middle',
    },
    { text: 'Ações', thClass: LEFT_HEADER_CLASS },
  ];

  const colWidths = ['w-[18%]', 'w-[52%]', 'w-[16%]', 'w-[14%]'];

  const handleSortOptions = (sortCamp: string, orderFlow: string) => {
    emit('update:sort', sortCamp, orderFlow);
  };

  const handleFilterClicked = () => {
    emit('filter-clicked');
  };
</script>

<template>
  <SearchResultsTable
    header-text="Documentos"
    table-class="w-full table-fixed"
    :col-widths="colWidths"
    :columns="columns"
    :row-component="SearchDocumentsTableRow"
    :revisions="revisions"
    :order-options="orderOptions"
    :is-filter-active="isFilterActive"
    @update:sort="handleSortOptions"
    @filter-clicked="handleFilterClicked"
  />
</template>
